export enum ErrorTypeOf {
  'duplicate_client_bsn' = 'duplicate_client_bsn',
  'linked_round_robin_supplier_conflict' = 'linked_round_robin_supplier_conflict',
}
